export default __webpack_public_path__ + "static/media/tianas3.9648dc2c.jpg";